module.exports = __webpack_public_path__ + "assets/img/search_icon.8be169d1.svg";